<template lang="pug">
v-app
  template(v-if="!loading")
    main-header(v-if="$route.path !== '/error404'")
    v-main
      router-view
    main-footer(v-if="$route.path !== '/error404'")
    whatsapp-button(:tel="tel && '55' + tel.replace(/[^0-9]/g, '')")
  v-sheet.d-flex.justify-center.align-center(
    v-else,
    height="100%",
    width="100%",
    color="transparent"
  )
    v-progress-circular(:size="50", color="primary", indeterminate)
  cookie-banner
</template>

<script>
import WhatsappButton from "@/components/buttons/WhatsappButton";
import MainHeader from "@/components/shell/MainHeader.vue";
import MainFooter from "@/components/shell/MainFooter.vue";
import CookieBanner from "@/components/widgets/CookieBanner.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    tel() {
      return this.$rest("informations").item.whatsapp;
    },
    name() {
      return this.$rest("informations").item.name || "";
    },
  },
  watch: {
    name() {
      document.title = `${this.$route.name} - ${this.name}`;
    },
    $route() {
      document.title = `${this.$route.name} - ${this.name}`;
    },
  },
  created() {
    document.title = `${this.$route.name} - ${this.name}`;
  },
  beforeCreate() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    MainHeader,
    MainFooter,
    WhatsappButton,
    CookieBanner,
  },
};
</script>

<style>
@import "./style/custom-user.css";
</style>
